import './ConfiguratorLink.scss';

import cn from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';

import {
  ConfiguratorLinkDefaultProps,
  ConfiguratorLinkPropTypes,
} from './ConfiguratorLink.proptypes';

const ConfiguratorLink = ({ className, link, num, onClick }) => {
  const { t } = useTranslation();

  return (
    <NavLink
      className={cn(className, 'configuration-link')}
      data-qa-id="configuration-link"
      onClick={onClick}
      to={`${link}#config-products-list`}
    >
      {t('ebat:entities:products.references.plural', {
        count: num,
      })}
    </NavLink>
  );
};

ConfiguratorLink.defaultProps = {
  ...ConfiguratorLinkDefaultProps,
};

ConfiguratorLink.propTypes = {
  ...ConfiguratorLinkPropTypes,
};

export default ConfiguratorLink;
